import React from "react";
import { isSupportBrowser } from "utils/formatter";
import Message from "components/Message";

const BrowserCheck = props => {
  const message = props.nallow
    ? [
      "サポート対象外のWebブラウザで表示されています。",
      "表示が乱れたり、一部の機能が使用できないことがあります。"
    ]
    : [
      "サポート対象外のWebブラウザで表示されています。表示が乱れたり、一部の機能が使用できないことがあります。"
    ];
  return (
    <div style={{ marginTop: isSupportBrowser() ? 0 : 10 }}>
      {!isSupportBrowser() && <Message messages={message} />}
    </div>
  );
};

export default BrowserCheck;



// WEBPACK FOOTER //
// ./src/components/BrowserCheck.jsx